module.exports = __webpack_public_path__ + "img/yxxx.2de68a0f.jpg";